import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import "./PreLogin.scss";

class FooterAdvisor extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }


  render() {
    const { } = this.state;
    return (
      <Fragment>
          <div className="row justify-content-center text-center" style={{ padding: "2vw" }}>
          <div className="col-md-2">
          <Link to="/about-us" className ="footer_link">                       
              <span className="mb-4 text_40 cursor" style={{ color: "rgba(255,255,255, 1) " }}
              >About FinApp</span>
                          </Link>
                          </div>
          <div className="col-md-2">
          <Link to="/privacy-policy" className ="footer_link">    
              <span className="mb-4 text_40 cursor" style={{ color: "rgba(255,255,255, 1) " }}
             >Privacy Policy</span>
              </Link>
          </div>
            <div className="col-md-2">
            <Link to="/refund-policy" className ="footer_link">    
                <span className="mb-4 text_40 cursor" style={{ color: "rgba(255,255,255, 1) " }}
                >Refund Policy</span>
                </Link>
            </div>
          <div className=" col-md-2">
          <Link to="/terms-conditions" className ="footer_link">    
              <span className="mb-4 text_40 cursor" style={{ color: "rgba(255,255,255, 1) " }}
              >Terms and Conditions</span>
              </Link>
            </div>
        </div>
      </Fragment>
    );
  }
}

export default FooterAdvisor;